import React from 'react'

export default function RnD() {
  return (
    <div>RnD</div>
  )
}
